export default "/images/select_opt2_ad_creative.gif?e216c56d6a203eb36e20e4d1f07454d9";